<mat-form-field appearance="outline" class="w-100">
    <mat-select [panelClass]="'custom-option-list'" disableOptionCentering [value]="value()" [disabled]="disabled()" (selectionChange)="onSelectionChange($event.value)">
        @if (!required()) {
            <mat-option [value]="''"> </mat-option>
        }
        @for (country of countries(); track trackByCountry($index, country)) {
            <mat-option [value]="country.name">
                {{ country.name }}
            </mat-option>
        }
    </mat-select>
</mat-form-field>
